import { useEffect, useRef } from 'react';
import { useOutletContext } from "react-router";
import * as d3 from 'd3';

//Create Root
function makeRoot(data) {
  var root = d3.hierarchy(data[0], function (d) { return d.children; })
    .sort((a, b, c) => d3.ascending(a.data.median, b.data.median, c));
  return (root)
}

export default function TreeChart(
  {
    data = [],
    valueInput = false,
    handleClick
  }
) {
  
  const [width, height] = useOutletContext();
  const svgRef = useRef(null);
  const tooltipRef = useRef(null);
  const linkRef = useRef(null);
  const labelRef = useRef(null);
  const circleRef = useRef(null);

// d3.select('div#chart-area')
// .on("dblclick", function(){nodedblclick()});

// function nodedblclick() {
//     Tooltip
//     .style("opacity", 0)
//     /*
//   d3.selectAll("path.link[name='Secretary']")
//   .style("stroke", "red")  
//   console.log($("path.link[name='Secretary']"))  
//   */
//   radialTreeGraph(root, selection = false);
// }


  useEffect(() => {

    //Constants
    let root = makeRoot(data)
    let height = document.getElementById("svgContainer").clientHeight
    let width = document.getElementById("svgContainer").clientWidth
    let radius = d3.min([height, width]) / 2
    let radialTree = d3.cluster()
      .size([2 * Math.PI, radius - 30])

    // SELECTIONS
    d3.select(svgRef.current)
      .attr("width", radius * 2)
      .attr("height", radius * 2)
      .attr("viewbox", `0 0 100 100`)
      .attr("preserveAspectRatio", "xMinYMin meet");

    const tooltip = d3
      .select(tooltipRef.current)
         
    const linkGroup = d3
      .select(linkRef.current)

    const circleGroup = d3
      .select(circleRef.current)
      .attr("transform", "translate(" + radius + "," + radius + ")")
    
    const labelGroup = d3
      .select(labelRef.current)
      .attr("transform", "translate(" + radius + "," + radius + ")"); 

    // SCALES
    var max_median = d3.max(root, function (d) { return d.data.median });
    var scaleSalary = d3
      .scaleLinear()
      .domain([0, max_median])
      .range([0, (30 * (radius / 500))]); //Scale based on size of Radius.  

    var scaleFont = d3
      .scaleLinear()
      .domain([0, 1])
      .range([0, radius / 500]); //Scale based on size of Radius.  

    // HANDLERS
    var mouseclick = function (e, d) {
      d3.select(this)
      .style("filter", "brightness(1)")
      tooltip
        .style("visibility", "hidden")
    let parent = d.parent ? d.parent.data.name : "root"        
    handleClick(d.data.name, parent, d.children);
    }  
    
var mouseover = function (d) {
  tooltip
    .style("visibility", "visible")
    d3.select(this)
      .style("filter", "brightness(1.5)");
}
var mousemove = function (e, d) {

  let tooltipText = ""

  if (d.data.name === "root") {
   tooltipText = 
   `Median: ${d3.format(".2s")(d.data.median)}<br>
    Min: ${d3.format(".2s")(d.data.min)}<br>
    Max: ${d3.format(".2s")(d.data.max)}<br>`;
  } else if (d3.format(".2s")(d.data.min) === d3.format(".2s")(d.data.max)) {
    tooltipText = `${d.data.name}<br>
    Salary: ${d3.format(".2s")(d.data.median)}` 
  } else {
    tooltipText = `${d.data.name}<br>
    Median: ${d3.format(".2s")(d.data.median)}<br>
    Min: ${d3.format(".2s")(d.data.min)}<br>
    Max: ${d3.format(".2s")(d.data.max)}<br>`
  }
  tooltip
    .html(tooltipText)
    .style("left", `${e.pageX + 10}px`)
    .style("top", `${e.pageY}px`)
}

var mouseleave = function (e, d) {
  d3.select(this)
  .style("filter", "brightness(1)")
  tooltip
    .style("visibility", "hidden");
}  
    // GROUPS
    linkGroup
      .selectAll("path")
      .data(radialTree(root).links())
      .join(
        enter => enter
        .append('path')
        .attr("class", (d, i) => { return `link-${i}` })
      .attr("name", d => d.target.data.name)
      .style("fill", "none")
      .style("stroke", "#7E7E7E")
      .attr("transform", "translate(" + radius + "," + radius + ")")
      .attr("d", d3.linkRadial()
        .angle(function (d) { return d.x; })
        .radius(function (d) { return d.y; })
      ),
        update => update
        .transition()
        .duration(1000)
        .attr("class", (d, i) => { return `link-${i}` })
      .attr("name", d => d.target.data.name)
      .style("fill", "none")
      .style("stroke", "#7E7E7E")
      .attr("transform", "translate(" + radius + "," + radius + ")")
      .attr("d", d3.linkRadial()
        .angle(function (d) { return d.x; })
        .radius(function (d) { return d.y; })
      ),
        exit => exit.remove()
      )

    circleGroup
      .selectAll("circle")
      .data(root.descendants())
      .join(
        enter => enter
        .append('circle')
        .attr("transform", d => `rotate(${d.x * 180 / Math.PI - 90}) translate(${d.y},0)`)
        .attr("r", d => (valueInput) ?
                        scaleSalary(d.data.median) - 2 :
                        d.children ? scaleFont(5) : scaleFont(2)),    
        update => update
        .transition()
        .duration(1000)
        .attr("name", d => d.data.name)
        .attr("transform", d => `rotate(${d.x * 180 / Math.PI - 90}) translate(${d.y},0)`)
        .attr("r", d => (valueInput) ?
                        scaleSalary(d.data.median) - 2 :
                        d.children ? scaleFont(5) : scaleFont(2)),       
        exit => exit.remove()
      )
      .on("mouseover", mouseover)
      .on("mousemove", (e, d) => mousemove(e, d))
      .on("mouseleave", mouseleave)
      .on("click", (e, d) => mouseclick(e,d))
      .attr("name", d => d.data.name)
      .attr("class", (d, i) => { return `circle-${i}` })
      .attr("stroke", "black")
      .attr("fill", d => (d.children) ? "#8A8ACB" : "#56B881")
      .attr("opacity", 0.9)
      .attr("cursor", "pointer")
      
     labelGroup
      .selectAll("text")
      .data(root.descendants())
      .join(
        enter => enter
        .append("text")
        .attr("text-anchor", "middle")
                .attr("class", "salary")
                .attr("alignment-baseline", "central")
                .style("pointer-events", "none")
                .attr("font-size", d => scaleSalary(d.data.median) - 2) // Use attr. and not style. or update will not work.
                .attr("transform", d => `
                rotate(${d.x * 180 / Math.PI - 90}) 
                translate(${d.y},0) 
                rotate(${d.x >= Math.PI ? 180 : 0})
              `)
                .text((d) => d3.format(".2s")(d.data.median))
                .style("opacity", d => (valueInput) ? 1 : 0),
        update => update
        .transition()
                .duration(1000)
                .attr("class", "salary")
                .attr("alignment-baseline", "central")
                .style("pointer-events", "none")
                .attr("font-size", d => scaleSalary(d.data.median) - 2) // Use attr. and not style. or update will not work.
                .attr("transform", d => `
                rotate(${d.x * 180 / Math.PI - 90}) 
                translate(${d.y},0) 
                rotate(${d.x >= Math.PI ? 180 : 0})
              `)
                .text((d) => d3.format(".2s")(d.data.median))
                .style("opacity", d => (valueInput) ? 1 : 0),
        (exit) => exit.remove()
      )
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, width, height, valueInput]); // redraw chart if data changes

  return (
    <div id="svgContainer" className="w-full h-full bg-th-blue-400 flex justify-center">
      <div className="
      invisible
      py-1
      px-2
      text-sm
      font-medium
      text-th-white
      absolute
      pointer-events-none 
      bg-th-blue 
      rounded-lg
      shadow-sm 
      transition-opacity duration-300
      " role="tooltip" ref={tooltipRef}>
      </div>
    <svg className="bg-th-blue-400" ref={svgRef}>
      <g className="linkGroup" ref={linkRef}></g>
      <g className="circleGroup" ref={circleRef}></g>
      <g className="labelGroup" ref={labelRef}></g>
    </svg>
    </div>)
};
